import serviceRecordDetailsLocale from './en.json'

const en = {
  serviceRecordDetails: serviceRecordDetailsLocale,
}

export default en
